module.exports = __webpack_public_path__ + "static/img/gamelist13.8332d67f.png";